/**
 * 非 VIP（vip_expire === 1）不允许进入用户端页面，统一跳转登录并提示「联系老师开通vip权限」
 * 与登录页的拦截配合：登录时也会校验，此处兜底所有路由
 */
import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import { getUserInfo } from 'network';
import { setUser } from 'actions';
import { clearNativeAuthMirror } from 'utils/nativePreferences';

const PUBLIC_PATHS = ['/', '/login', '/register', '/forgotPassword', '/download', '/about'];
const isAboutPath = (path) => path && path.startsWith('/about');
// 商城模块无需登录
const isMallPath = (path) => path && path.startsWith('/mall');

const getToken = () => {
  try {
    const raw = localStorage.getItem('_pwd');
    if (!raw) return null;
    const obj = JSON.parse(raw);
    return obj && (typeof obj === 'string' ? obj : obj.token);
  } catch (e) {
    return null;
  }
};

const VipGuard = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user?.user || null);
  const checkingRef = useRef(false);
  const pathname = location.pathname;

  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    if (PUBLIC_PATHS.includes(pathname)) return;
    if (isAboutPath(pathname)) return;
    if (isMallPath(pathname)) return;

    const token = getToken();
    if (!token) return;

    const redirectNonVip = () => {
      localStorage.removeItem('_pwd');
      clearNativeAuthMirror();
      message.warning('联系老师开通vip权限');
      navigate('/login', { replace: true });
    };

    if (user && user.vip_expire === 1) {
      redirectNonVip();
      return;
    }

    if (user != null) return;

    if (checkingRef.current) return;
    checkingRef.current = true;
    getUserInfo({})
      .then((res) => {
        if (res?.code === 0 && res?.data) {
          dispatch(setUser(res.data));
          if (res.data.vip_expire === 1) redirectNonVip();
        }
      })
      .catch(() => {})
      .finally(() => {
        checkingRef.current = false;
      });
  }, [pathname, user, dispatch, navigate]);

  return children;
};

export default VipGuard;
